import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as dayjs from 'dayjs';
import { Dayjs } from 'dayjs';
import { TrendsService } from '../../services/trends/trends.service';
import { calendar } from '../global-variables';
import { NgFor, NgClass } from '@angular/common';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

export interface Ranges {
  index: number;
  label: string;
  focus: boolean;
  value: number;
  limit: number;
}
export interface selected {

}
@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    imports: [NgFor, NgClass, NgxDaterangepickerMd]
})
export class CalendarComponent {
  @Output() newItemEvent = new EventEmitter();
  id = "calendar"
  title = 'calendar';
  limits = { minDate: this.toStringAndSplit(dayjs().subtract(469, 'day')), maxDate: this.toStringAndSplit(dayjs()) }
  ranges: Ranges[] = [
    { index: 0, label: 'Today', focus: false, value: 0, limit: this.calculateLimit('day') },
    { index: 1, label: 'This Week', focus: false, value: 0, limit: this.calculateLimit('week') },
    { index: 2, label: 'This Month', focus: false, value: 0, limit: this.calculateLimit('month') },
    { index: 3, label: 'This Quarter', focus: false, value: 0, limit: this.calculateLimit('quarter') },
    { index: 4, label: 'This Year', focus: false, value: 0, limit: this.calculateLimit('year') },
    { index: 5, label: 'This Financial Year', focus: false, value: 0, limit: 0 },
  ]
  locale = {
    format: 'DD/MM/YYYY',
    displayFormat: 'DD/MM/YYYY',
    daysOfWeek: calendar.weeks,
    monthNames: calendar.months,
    firstDay: 0
  };
  requestDate = true;
  responseDate = false;
  financialYear = new Date();
  buttonClicked = false;
  selected = {
    startDate: dayjs().startOf('month'),
    endDate: dayjs(),
  };
  constructor(private trendsService: TrendsService) { }

  ngOnInit() {
    if (this.financialYear.getMonth() >= 3)
      this.financialYear = new Date('04/01/' + new Date().getFullYear().toString());
    else if (this.financialYear.getMonth() < 3)
      this.financialYear = new Date('04/01/' + (new Date().getFullYear() - 1).toString());
    this.finYearCount();
    if (calendar.startDate && calendar.endDate) {
      this.selected = { startDate: dayjs(calendar.startDate), endDate: dayjs(calendar.endDate) }
    } else
      this.updateRangesCalendar(this.ranges[2].label);
    if (calendar.focusedIndex < this.ranges.length)
      this.ranges[calendar.focusedIndex].focus = true
  }

  calculateLimit(duration: any) {
    const maxDate = dayjs(this.limits.maxDate)
    const minDate = dayjs(this.limits.minDate)
    if (duration == 'quarter')
      return Math.floor(maxDate.endOf('month').diff(minDate.startOf('month'), 'month') / 3)
    return maxDate.endOf(duration).diff(minDate.startOf(duration), duration)
  }

  finYearCount() {
    let count = this.ranges[4].limit
    const minDate = dayjs(this.limits.minDate)
    const maxDate = dayjs(this.limits.maxDate)
    if (minDate.month() < 3) {
      count++;
    }
    if (maxDate.month() < 3) {
      count--;
    }
    this.ranges[5].limit = count
  }

  calculateQuarterMonth(month: number) {
    const quarter = Math.floor(month / 3);
    return month - (quarter * 3)
  }

  updateRangesCalendar(rangeName: string, thisTime?: boolean): void {
    for (let i of this.ranges) {
      i.focus = i.label == rangeName
      if (i.focus)
        calendar.focusedIndex = i.index;
      if (thisTime)
        i.value = 0;
    }
    const today = dayjs()
    const dayInMonth = today.date() - 1
    if (rangeName === this.ranges[0].label) { // day
      this.selected.endDate = this.selected.startDate = today.subtract(this.ranges[0].value, 'day')
    } else if (rangeName === this.ranges[1].label) { // week
      this.selected.startDate = this.ranges[1].value == this.ranges[1].limit ? dayjs(this.limits.minDate) : today.subtract(today.day(), 'day').subtract(this.ranges[1].value, 'week')
      this.selected.endDate = this.ranges[1].value == 0 ? today : this.selected.startDate.endOf('week')
    } else if (rangeName === this.ranges[2].label) { // month
      this.selected.startDate = this.ranges[2].value == this.ranges[2].limit ? dayjs(this.limits.minDate) : today.subtract(dayInMonth, 'day').subtract(this.ranges[2].value, 'month')
      this.selected.endDate = this.ranges[2].value == 0 ? today : this.selected.startDate.endOf('month')
    } else if (rangeName === this.ranges[3].label) { // quarter
      let quarter = this.calculateQuarterMonth(today.month());
      this.selected.startDate = this.ranges[3].value == this.ranges[3].limit ? dayjs(this.limits.minDate) : today.subtract(dayInMonth, 'day').subtract(quarter, 'month').subtract(this.ranges[3].value * 3, 'month')
      quarter = this.calculateQuarterMonth(this.selected.startDate.month());
      this.selected.endDate = this.ranges[3].value == 0 ? today : this.selected.startDate.endOf('month').add(2 - quarter, 'month')
    } else if (rangeName === this.ranges[4].label) { // year
      this.selected.startDate = this.ranges[4].value == this.ranges[4].limit ? dayjs(this.limits.minDate) : today.startOf('year').subtract(this.ranges[4].value, 'year')
      this.selected.endDate = this.ranges[4].value == 0 ? today : this.selected.startDate.endOf('year')
    } else if (rangeName === this.ranges[5].label) { // financial year
      this.selected.startDate = this.ranges[5].value == this.ranges[5].limit ? dayjs(this.limits.minDate) : dayjs(this.financialYear).subtract(this.ranges[5].value * 12, 'month')
      this.selected.endDate = this.ranges[5].value == 0 ? today : this.selected.startDate.add(this.finYear(this.selected.startDate), 'month').endOf('month')
    }
  }

  finYear(date: Dayjs) {
    const month = date.month()
    return month > 2 ? 14 - month : 2 - month;
  }

  changeRange(range: string, increase: boolean) {
    for (let i of this.ranges)
      if (range == i.label && !(i.value <= 0 && increase) && !(i.value >= i.limit && !increase))
        i.value = increase ? i.value - 1 : i.value + 1
    this.updateRangesCalendar(range)
  }

  choosedDate(event: { startDate: dayjs.Dayjs; endDate: dayjs.Dayjs; }) {
    for (let i of this.ranges)
      i['focus'] = false;
    calendar.focusedIndex = this.ranges.length
    this.selected.startDate = event.startDate
    this.selected.endDate = event.endDate
  }

  reset() {
    for (let i of this.ranges)
      i.value = 0;
    this.updateRangesCalendar(this.ranges[2].label);
  }

  apply() {
    const startDate = this.selected.startDate.year() + ("0" + (this.selected.startDate.month() + 1)).slice(-2) + (this.selected.startDate.date() < 10 ? "0" + this.selected.startDate.date(): this.selected.startDate.date());
    const endDate = this.selected.endDate.year() + ("0" + (this.selected.endDate.month() + 1)).slice(-2) + (this.selected.endDate.date() < 10 ? "0" + this.selected.endDate.date(): this.selected.endDate.date());
    this.update(this.selected)
    this.newItemEvent.emit({ selected: this.selected, requestDate: this.requestDate })
    this.trendsService.updateTrends({ startDate: startDate, endDate: endDate })
  }

  update(input: { startDate: Dayjs; endDate: Dayjs; }) {
    calendar.startDate = this.toStringAndSplit(input.startDate)
    calendar.endDate = this.toStringAndSplit(input.endDate)
  }

  toStringAndSplit(date: Dayjs) {
    return date.toString().slice(0, -13).trim()
  }

  viewBy(event: boolean) {
    if (event) {
      this.requestDate = event;
      this.responseDate = !this.requestDate;
    } else {
      this.responseDate = !event;
      this.requestDate = !this.responseDate;
    }
  }

}
